import React from 'react'

import Icon from 'Core/Components/Icon'
import { AssetController } from 'RLX/Views/Dashboard/Panes/Assets/AssetController'
import { imageAssetTypes, getIconForAsset } from 'RLX/Views/Dashboard/Panes/Assets/assets-utils'

import './ImageSelector.scss'

class ImageSelector extends AssetController {
    constructor (props) {
        super(props)

        this.state = {...this.state, modalVisible: false }
        this.render = this.render.bind(this);

        window.addEventListener('keydown', (evt) => {
            if (evt.key === 'Escape') {
                this.setState({ ...this.state, modalVisible: false })
            }
        });

        this.onAfterUpload = this.onAfterUpload.bind(this);
    }

    onAfterUpload (newUris) {
        this.selectImage(newUris[0]);
    }

    selectImage (uri) {
        this.props.onSelect(encodeURIComponent(uri).split('%2F').join('/'));

        this.setState({ ...this.state, modalVisible: false });
    }

    render () {
        const filteredAssets = this.getFilteredAssets();
        const breadcrumbs = this.getBreadcrumbs();

        return (
            <React.Fragment>
                <a title="Select or upload an asset" onClick={() => this.setState({ ...this.state, modalVisible: true }) }>
                    <Icon fa="folder-open"/>
                </a>
                <div
                    className="ImageSelector-wrapper"
                    style={{ opacity: this.state.modalVisible ? 1 : 0, pointerEvents: this.state.modalVisible ? 'all' : 'none' }}
                    onClick={() => this.setState({ ...this.state, modalVisible: false })}>
                    <div className="ImageSelector-inner" onClick={(evt) => evt.stopPropagation()}>
                        <div className="ImageSelector-toolbar">
                            <button
                                style={{ backgroundColor: '#efefef', paddingLeft: 12, paddingRight: 12, marginRight: 0 }}
                                onClick={() => this.goToParentDirectory()}
                                disabled={this.state.activeDirectory === '/assets'}>
                                <Icon fa="arrow-up" style={{ transform: 'scale(1.3)' }} />
                            </button>
                            <button
                                style={{ backgroundColor: '#efefef', paddingLeft: 12, paddingRight: 12 }}
                                onClick={() => this.selectDirectory('/assets')}
                                disabled={this.state.activeDirectory === '/assets'}>
                                <Icon fa="home" style={{ transform: 'scale(1.5)', transformOrigin: 'center top' }} />
                            </button>
                            <span style={{ margin: 10, color: '#AAA' }}>
                                <Icon fa="folder-open-o" style={{ transform: 'scale(1.3)' }} />
                            </span>
                            <div className="ImageSelector-breadcrumb">
                                {breadcrumbs.map(crumb => (
                                    <button key={crumb.path} onClick={() => this.selectDirectory(crumb.path)}>
                                        /{crumb.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                        {/* UPLOAD BAR */}
                        {this.state.modalVisible ? (
                            <div
                                style={{ display: 'flex', padding: 10, flex: '1 0 66%', position: 'relative' }}>
                                <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'row', border: '2px dashed silver', height: '100%', padding: '10px 5px', cursor: 'pointer' }}>
                                    <Icon style={{ fontSize: 30, marginTop: 5, marginLeft: 5, marginRight: 20, color: 'rgb(228, 153, 149)' }} fa={'cloud-upload'}/>
                                    <div>
                                        <div className="f-row items-end">
                                            <h4 style={{ margin: 0, padding: 0, marginRight: 5, marginBottom: 0, paddingBottom: 0 }}>Click here or drop files to upload</h4>
                                            <p style={{ fontSize: 13, padding: 0, margin: 0, marginTop: -4, marginRight: 5 }}>to <u>{this.state.activeDirectory}</u></p>
                                        </div>
                                        <p style={{ fontSize: 10, maxWidth: 400, lineHeight: '14px', padding: 0, margin: 0, marginTop: 0, fontWeight: 300, marginRight: 5 }}>File types: {this.state.uploadTypes.join(', ')}</p>
                                    </div>
                                    <input
                                        onChange={this.onFileInputChange}
                                        ref={this.ref}
                                        multiple
                                        type="file"
                                        accept={this.state.uploadTypes.map(t => `.${t}`).join(',')}
                                        style={{position: 'absolute', opacity: 0.01, width: '100%', height: '100%', cursor: 'pointer' }}
                                    />
                                </div>
                            </div>
                        ) : null}
                        <div className="ImageSelector-list">
                            {filteredAssets.map(asset => (
                                <div
                                    className={`ImageSelector-item ${this.state.selection.includes(asset.uri) ? 'ImageSelector-item--selected' : ''}`}
                                    onDoubleClick={() => setTimeout(asset.type === 'directory' ? this.selectDirectory(asset.uri) : this.selectImage(asset.uri))}
                                    onClick={() => this.setState({ ...this.state, selection: [asset.uri] })}>
                                    {imageAssetTypes.includes(asset.type.toLowerCase()) ? (
                                        <img
                                            src={asset.uri}
                                            style={{ maxWidth: '70px', maxHeight: '70px' }}
                                          />
                                    ) : (
                                        <div>
                                            <Icon style={{ fontSize: 30 }} fa={getIconForAsset(asset)}/>
                                            <h3 style={{ marginTop: 5, fontWeight: 200 }}>{asset.type === 'directory' ? '' : '.' + asset.type.toLowerCase()}</h3>
                                        </div>
                                    )}
                                    <p style={{ fontSize: 12, fontWeight: 300 }}>{asset.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default ImageSelector;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ImageSelector/ImageSelector.jsx